<div class="pt-3 px-5 lg:px-8 pb-5 mb-1 font-base font-normal text-neutral-600">
  <div class="font-accent text-md lg:text-2xl font-bold leading-6 text-black">
    {{ 'shop-informations.address' | translate }}
  </div>
  <div class="text-base lg:text-md">
    @if (address) {
      <span>{{ address }},</span>
    }
    @if (postcode) {
      <span> {{ postcode }}</span>
    }
    @if (city) {
      <span> {{ city }}</span>
    }
  </div>
  @if (distance) {
    <div class="text-base lg:text-md">À {{ formattedDistance }}</div>
  }
  <div class="mt-3">
    @if (localization) {
      <app-button-atom
        [size]="'S'"
        [color]="'primary'"
        [label]="'shop-informations.location' | translate"
        [type]="'light'"
        class="mr-3"
        (click)="getLocalization.emit($event)"
      ></app-button-atom>
    }
    @if (itinerary) {
      <app-button-atom
        [size]="'S'"
        [color]="'primary'"
        [label]="'shop-informations.itinerary' | translate"
        [type]="'light'"
        (click)="getItinerary.emit($event)"
      ></app-button-atom>
    }
  </div>
</div>
